module.exports = __webpack_public_path__ + "static/media/trash.bdf35b9b.svg";